import React from 'react';

export class Widget extends React.Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    return (
      <div id="ehelp-widget"></div>
    );
  }
}
